import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import o from "./TreeNode.js";
import { pxfy as i } from "../../../../../../seemly@0.3.10/node_modules/seemly/es/css/index.js";
import n from "../../_internal/fade-in-expand-transition/src/FadeInExpandTransition.js";
import { defineComponent as p, h as r } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
const u = p({
  name: "TreeMotionWrapper",
  props: {
    clsPrefix: {
      type: String,
      required: !0
    },
    height: Number,
    nodes: {
      type: Array,
      required: !0
    },
    mode: {
      type: String,
      required: !0
    },
    onAfterEnter: {
      type: Function,
      required: !0
    }
  },
  render() {
    const {
      clsPrefix: e
    } = this;
    return r(n, {
      onAfterEnter: this.onAfterEnter,
      appear: !0,
      reverse: this.mode === "collapse"
    }, {
      default: () => r("div", {
        class: [`${e}-tree-motion-wrapper`, `${e}-tree-motion-wrapper--${this.mode}`],
        style: {
          height: i(this.height)
        }
      }, this.nodes.map((t) => r(o, {
        clsPrefix: e,
        tmNode: t
      })))
    });
  }
});
export {
  u as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/tree/src/MotionWrapper.js
// module id = 1757
// module chunks = 67